var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIntegrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 34.5,
    fill: "#FFF8FB",
    stroke: "#FFD8E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 46H23.5C18.8 46 15 42.2 15 37.5C15 33.2 18.2 29.6 22.4 29.1C23.9 23.9 28.7 20 34.5 20C40.4 20 45.4 24.1 46.7 29.7C52.5 29.9 57 34.6 57 40.4C57 46.3 52.2 51 46.4 51H46",
    stroke: "#FF2775",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51V31",
    stroke: "#FF2775",
    strokeWidth: 2.1,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38L36 31L43 38",
    stroke: "#FF2775",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntegrate);
export default __webpack_public_path__ + "static/media/icon-integrate.c3d12db14edd3a61edd1dd555fca5957.svg";
export { ForwardRef as ReactComponent };